
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("iSkY9", function(module, exports) {
$parcel$export(module.exports, "default", () => $316fd619de8f1b21$export$2e2bcd8739ae039);
/* time-picker.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $53JkC = parcelRequire("53JkC");
var $lMRHO = parcelRequire("lMRHO");

var $kIUP1 = parcelRequire("kIUP1");

var $4TRbS = parcelRequire("4TRbS");

var $1OdZP = parcelRequire("1OdZP");

var $87EHs = parcelRequire("87EHs");

var $aJ64v = parcelRequire("aJ64v");

var $7q8Sl = parcelRequire("7q8Sl");

var $gdUUy = parcelRequire("gdUUy");

var $udzoQ = parcelRequire("udzoQ");

var $2mnxD = parcelRequire("2mnxD");

var $eOzrv = parcelRequire("eOzrv");

var $eIbNg = parcelRequire("eIbNg");

var $c56CN = parcelRequire("c56CN");

var $dJKth = parcelRequire("dJKth");

var $eFOKM = parcelRequire("eFOKM");

var $i7VIS = parcelRequire("i7VIS");

var $6Ysp1 = parcelRequire("6Ysp1");

var $beM1L = parcelRequire("beM1L");

var $ieM8d = parcelRequire("ieM8d");
const $316fd619de8f1b21$var$packageName = undefined;
const $316fd619de8f1b21$var$packageVersion = undefined;
const $316fd619de8f1b21$var$defaultTimeFormat = 'h:mma';
const $316fd619de8f1b21$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $316fd619de8f1b21$var$styles = {
    pickerContainer: "_kqswh2mm"
};
const $316fd619de8f1b21$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $316fd619de8f1b21$var$packageName,
    packageVersion: $316fd619de8f1b21$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $316fd619de8f1b21$var$TimePicker = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', openTimeLabel: openTimeLabel = 'Open time picker', onBlur: providedOnBlur = (0, $1OdZP.default), onChange: providedOnChange = (0, $1OdZP.default), onFocus: providedOnFocus = (0, $1OdZP.default), parseInputValue: parseInputValue, placeholder: placeholder, selectProps: selectProps = {}, shouldShowTimeButton: shouldShowTimeButton = false, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $eIbNg.defaultTimes), value: providedValue }, _ref)=>{
    const [containerRef, setContainerRef] = (0, $bSJIT.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $bSJIT.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $bSJIT.useState)(false);
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(defaultIsOpen);
    const [shouldFocusTimeInput, setShouldFocusTimeInput] = (0, $bSJIT.useState)(false);
    const [value, setValue] = (0, $bSJIT.useState)(defaultValue);
    const l10n = (0, $7q8Sl.createLocalizationProvider)(locale);
    const localeTimeFormat = (0, $bSJIT.useMemo)(()=>(0, $gdUUy.fg)('platform-dst-locale-aware-time-parsing') ? (0, $aJ64v.getTimeFormat)(locale) : undefined, [
        locale
    ]);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $bSJIT.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$316fd619de8f1b21$var$analyticsAttributes
    });
    (0, $bSJIT.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!isOpen || !shouldFocusTimeInput) return;
        const innerCombobox = containerRef === null || containerRef === void 0 ? void 0 : containerRef.querySelector('[role="combobox"]');
        innerCombobox === null || innerCombobox === void 0 || innerCombobox.focus();
        setShouldFocusTimeInput(false);
    }, [
        containerRef,
        isOpen,
        shouldFocusTimeInput
    ]);
    const onChange = (0, $bSJIT.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue ? parseInputValue(inputValue, timeFormat || $316fd619de8f1b21$var$defaultTimeFormat) : (0, $eFOKM.default)(inputValue, localeTimeFormat);
            } catch  {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $53JkC.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const onTimeButtonClick = (event)=>{
        const nextIsOpen = !isOpen;
        setIsOpen(nextIsOpen);
        if (nextIsOpen) {
            var _otherSelectProps$onM;
            (_otherSelectProps$onM = otherSelectProps.onMenuOpen) === null || _otherSelectProps$onM === void 0 || _otherSelectProps$onM.call(otherSelectProps);
        } else {
            var _otherSelectProps$onM2;
            (_otherSelectProps$onM2 = otherSelectProps.onMenuClose) === null || _otherSelectProps$onM2 === void 0 || _otherSelectProps$onM2.call(otherSelectProps);
        }
        event.stopPropagation();
    };
    const onTimeButtonKeyDown = (event)=>{
        if (!isOpen && (event.key === ' ' || event.key === 'Enter')) setShouldFocusTimeInput(true);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $2mnxD.default) : (0, $eOzrv.default);
    const onInputChange = (inputValue, actionMeta)=>{
        var _otherSelectProps$onI;
        (_otherSelectProps$onI = otherSelectProps.onInputChange) === null || _otherSelectProps$onI === void 0 || _otherSelectProps$onI.call(otherSelectProps, inputValue, actionMeta);
        // Keep the menu-opening behavior aligned with DatePicker: entering text
        // opens the available options, even when the optional time button disables
        // opening on focus.
        if (actionMeta.action === 'input-change') setIsOpen(true);
    };
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || $316fd619de8f1b21$var$defaultTimeFormat);
        const date = (0, $eFOKM.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $lMRHO.default)(date)) return time;
        if (timeFormat) return (0, $53JkC.default)(date, (0, $i7VIS.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const valueId = (0, $bSJIT.useId)();
    const SingleValue = (0, $ieM8d.makeSingleValue)({
        id: valueId,
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $c56CN.EmptyComponent),
        // Select owns top-layer positioning; only the legacy path needs a separate wrapper.
        ...!(0, $gdUUy.fg)('platform-dst-top-layer') && {
            Menu: (0, $dJKth.FixedLayerMenu)
        },
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $c56CN.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    const fullOpenTimeLabel = label ? `${label}, ${openTimeLabel}` : openTimeLabel;
    const isInputMotionEnabled = (0, $gdUUy.fg)('platform-dst-motion-uplift-input');
    const mergedStyles = (0, $udzoQ.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...isInputMotionEnabled && !isDisabled ? {
                    transition: base.transition ?? "var(--ds-input, background-color border-color box-shadow 150ms cubic-bezier(0.4, 1, 0.6, 1))"
                } : {}
            }),
        menu: (base)=>({
                ...base,
                ...$316fd619de8f1b21$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        className: (0, $9fU1q.default)([
            $316fd619de8f1b21$var$styles.pickerContainer
        ]),
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: !shouldShowTimeButton,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $beM1L.placeholderDatetime)),
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps,
                onInputChange: onInputChange
            }),
            shouldShowTimeButton && !isDisabled ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $6Ysp1.PickerButtonContainer), {
                hasClearIndicator: renderIconContainer,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
                    appearance: "subtle",
                    label: fullOpenTimeLabel,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87EHs))), {
                            ...iconProps,
                            color: "var(--ds-icon, #292A2E)"
                        }),
                    onClick: onTimeButtonClick,
                    onKeyDown: onTimeButtonKeyDown,
                    testId: testId && `${testId}--open-time-button`
                })
            }) : null
        ]
    });
});
var $316fd619de8f1b21$export$2e2bcd8739ae039 = $316fd619de8f1b21$var$TimePicker;

});
parcelRegister("aJ64v", function(module, exports) {
$parcel$export(module.exports, "getTimeFormat", () => $4243fecb7f46c02c$export$d039bddcd4b404fc);

var $l8vXm = parcelRequire("l8vXm");
const $4243fecb7f46c02c$export$d039bddcd4b404fc = (locale)=>{
    const normalizedLocale = (0, $l8vXm.normalizeLocale)(locale);
    const formatter = new Intl.DateTimeFormat(normalizedLocale, {
        hour: 'numeric',
        minute: 'numeric'
    });
    const dayPeriod = (hour)=>{
        var _formatter$formatToPa;
        return ((_formatter$formatToPa = formatter.formatToParts(new Date(2020, 0, 1, hour)).find((part)=>part.type === 'dayPeriod')) === null || _formatter$formatToPa === void 0 ? void 0 : _formatter$formatToPa.value) || '';
    };
    const localizedDigits = new Intl.NumberFormat(normalizedLocale, {
        useGrouping: false
    }).format(9876543210);
    return {
        hourCycle: formatter.resolvedOptions().hourCycle,
        dayPeriods: {
            am: dayPeriod(9),
            pm: dayPeriod(21)
        },
        digits: Object.fromEntries(Array.from(localizedDigits).map((digit, index)=>[
                digit,
                String(9 - index)
            ])),
        timeParts: formatter.formatToParts(new Date(2020, 0, 1, 21, 32))
    };
};

});

parcelRegister("eIbNg", function(module, exports) {
$parcel$export(module.exports, "defaultTimes", () => $db1c166854d4b393$export$b42ffb9f09b1861b);
const $db1c166854d4b393$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];

});

parcelRegister("dJKth", function(module, exports) {
$parcel$export(module.exports, "FixedLayerMenu", () => $e0080073ec2a10e7$export$982ad994195b4356);
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $kbBdI = parcelRequire("kbBdI");

var $1rWQP = parcelRequire("1rWQP");
const $e0080073ec2a10e7$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $1rWQP.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $kbBdI.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        testId: selectProps.testId
    });

});

parcelRegister("eFOKM", function(module, exports) {
$parcel$export(module.exports, "default", () => $6926645a1c03a5cd$export$2e2bcd8739ae039);

var $cIPii = parcelRequire("cIPii");

var $j3u1e = parcelRequire("j3u1e");

var $iS4cV = parcelRequire("iS4cV");
function $6926645a1c03a5cd$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $6926645a1c03a5cd$var$parseLegacyTime(time, allowCompactTime = false) {
    const trimmedTime = time.toString().trim();
    const compactTime = allowCompactTime ? trimmedTime.match(/^\d{5}$/) : null;
    if (compactTime) {
        const normalizedTime = `0${compactTime[0]}`;
        const hour = Number(normalizedTime.slice(0, 2));
        const minute = Number(normalizedTime.slice(2, 4));
        const seconds = Number(normalizedTime.slice(4, 6));
        if (minute <= 59 && seconds <= 59) return $6926645a1c03a5cd$var$assignToDate({
            hour: hour,
            minute: minute,
            seconds: seconds
        });
    }
    if (/^\d{5}$/.test(trimmedTime)) throw RangeError('invalid time format');
    if (!(0, $j3u1e.isValid)(trimmedTime)) throw RangeError('invalid time format');
    const time1 = (0, $iS4cV.removeSpacer)(trimmedTime);
    const time2 = (0, $cIPii.convertTo24hrTime)(time1);
    if (!time2) throw RangeError('invalid time format');
    return $6926645a1c03a5cd$var$assignToDate({
        ...time2,
        hour: time2.hour === 24 ? 0 : time2.hour
    });
}
const $6926645a1c03a5cd$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const $6926645a1c03a5cd$var$normalizeDigits = (time, timeFormat)=>Array.from(time, (character)=>timeFormat.digits[character] || character).join('');
const $6926645a1c03a5cd$var$isValidHourForCycle = (hour, hourCycle)=>hourCycle === 'h11' ? hour <= 11 : hourCycle === 'h12' ? hour >= 1 && hour <= 12 : hour <= 24;
function $6926645a1c03a5cd$var$parseExactLocalizedTime(time, timeFormat) {
    if (!timeFormat.timeParts) return undefined;
    const dayPeriods = Object.entries(timeFormat.dayPeriods).filter(([, value])=>value);
    const groupTypes = [];
    const patternParts = timeFormat.timeParts.map((part)=>{
        if (part.type === 'hour' || part.type === 'minute' || part.type === 'second') {
            groupTypes.push(part.type);
            return part.type === 'hour' ? '(\\d{1,2})' : '(\\d{2})';
        }
        if (part.type === 'dayPeriod') {
            if (dayPeriods.length === 0) return null;
            groupTypes.push('dayPeriod');
            return `(${dayPeriods.map(([, value])=>$6926645a1c03a5cd$var$escapeRegExp(value)).join('|')})`;
        }
        if (part.type === 'literal') return $6926645a1c03a5cd$var$escapeRegExp(part.value);
        return null;
    });
    if (patternParts.some((part)=>part === null)) return undefined;
    const match = time.match(new RegExp(`^${patternParts.join('')}$`, 'u'));
    if (!match) return undefined;
    const values = Object.fromEntries(groupTypes.map((type, index)=>[
            type,
            match[index + 1]
        ]));
    if (!values.hour || !values.minute) return undefined;
    const hour = Number(values.hour);
    const minute = Number(values.minute);
    const seconds = Number(values.second || '0');
    if (minute > 59 || seconds > 59) return null;
    if (values.dayPeriod) {
        var _dayPeriods$find;
        const period = (_dayPeriods$find = dayPeriods.find(([, value])=>value === values.dayPeriod)) === null || _dayPeriods$find === void 0 ? void 0 : _dayPeriods$find[0];
        if (!period || !$6926645a1c03a5cd$var$isValidHourForCycle(hour, timeFormat.hourCycle)) return null;
        return $6926645a1c03a5cd$var$assignToDate({
            hour: period === 'pm' ? hour % 12 + 12 : hour % 12,
            minute: minute,
            seconds: seconds
        });
    }
    if (hour > 24) return null;
    return $6926645a1c03a5cd$var$assignToDate({
        hour: hour === 24 ? 0 : hour,
        minute: minute,
        seconds: seconds
    });
}
function $6926645a1c03a5cd$var$parseLocalizedTime(normalizedTime, timeFormat) {
    const dayPeriods = Object.entries(timeFormat.dayPeriods).filter(([, value])=>value);
    const markers = dayPeriods.filter(([, value])=>new RegExp($6926645a1c03a5cd$var$escapeRegExp(value), 'u').test(normalizedTime));
    if (markers.length === 0) return undefined;
    if (markers.length !== 1) return null;
    const [[period, marker]] = markers;
    const numericTime = normalizedTime.replace(new RegExp($6926645a1c03a5cd$var$escapeRegExp(marker), 'u'), '').trim();
    const match = numericTime.match(/^(\d{1,2})(?:[:.](\d{2}))?(?:[:.](\d{2}))?$/);
    if (!match) return null;
    const [, hourValue, minuteValue = '0', secondValue = '0'] = match;
    const hour = Number(hourValue);
    const minute = Number(minuteValue);
    const seconds = Number(secondValue);
    if (!$6926645a1c03a5cd$var$isValidHourForCycle(hour, timeFormat.hourCycle) || minute > 59 || seconds > 59) return null;
    return $6926645a1c03a5cd$var$assignToDate({
        hour: period === 'pm' ? hour % 12 + 12 : hour % 12,
        minute: minute,
        seconds: seconds
    });
}
function $6926645a1c03a5cd$export$2e2bcd8739ae039(time, timeFormat) {
    if (timeFormat) {
        const normalizedTime = $6926645a1c03a5cd$var$normalizeDigits(time, timeFormat);
        const exactLocalizedTime = $6926645a1c03a5cd$var$parseExactLocalizedTime(normalizedTime, timeFormat);
        if (exactLocalizedTime instanceof Date) return exactLocalizedTime;
        if (exactLocalizedTime === null) throw RangeError('invalid time format');
        const localizedTime = $6926645a1c03a5cd$var$parseLocalizedTime(normalizedTime, timeFormat);
        if (localizedTime instanceof Date) return localizedTime;
        if (localizedTime === null) throw RangeError('invalid time format');
        return $6926645a1c03a5cd$var$parseLegacyTime(normalizedTime, true);
    }
    return $6926645a1c03a5cd$var$parseLegacyTime(time);
}

});
parcelRegister("cIPii", function(module, exports) {
$parcel$export(module.exports, "convertTo24hrTime", () => $4575cb2621ed91e8$export$6137ce2c9c5166bb);
const $4575cb2621ed91e8$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $4575cb2621ed91e8$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $4575cb2621ed91e8$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $4575cb2621ed91e8$var$map24[hour];
    return hour;
}
function $4575cb2621ed91e8$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $4575cb2621ed91e8$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $4575cb2621ed91e8$var$formatSemi24(timeArray[0].trim());
    const hour = $4575cb2621ed91e8$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $4575cb2621ed91e8$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $4575cb2621ed91e8$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}

});

parcelRegister("j3u1e", function(module, exports) {
$parcel$export(module.exports, "isValid", () => $a369c4bab01bbe53$export$1ea939691cdc45b8);
function $a369c4bab01bbe53$export$1ea939691cdc45b8(timeString) {
    /**
   * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
   */ const time = timeString.trim().match(/^([012]?[\d])(?:[:.]?([0-5][\d]))?(?:[:.]?([0-5][\d]))?\s*([ap](?:\s*\.?\s*m\.?)?)?$/i);
    /**
   * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
   */ const time24hr = timeString.trim().match(/^([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?$/);
    /**
   * Convert `2:34:56 pm` down to `23456`
   */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}

});

parcelRegister("iS4cV", function(module, exports) {
$parcel$export(module.exports, "removeSpacer", () => $c5784b74fbea582d$export$49c81d9f91c512ce);
function $c5784b74fbea582d$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}

});




//# sourceMappingURL=shared.94aedf05.js.map
